import type { ContainerDump, ContainerDumpFilterInput, CreateContainerDumpInput, PaginatedResult, UpdateContainerDumpInput } from '@container-system/shared';
import { apiRequest, buildQuery } from './client';

export function listContainerDumps(filter: Partial<ContainerDumpFilterInput>) {
  return apiRequest<PaginatedResult<ContainerDump>>(`/api/container-dumps${buildQuery(filter)}`);
}

export function getContainerDump(id: string) {
  return apiRequest<ContainerDump>(`/api/container-dumps/${id}`);
}

export function createContainerDump(input: CreateContainerDumpInput) {
  return apiRequest<ContainerDump>('/api/container-dumps', { method: 'POST', body: JSON.stringify(input) });
}

export function updateContainerDump(id: string, input: UpdateContainerDumpInput) {
  return apiRequest<ContainerDump>(`/api/container-dumps/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export function deleteContainerDump(id: string) {
  return apiRequest<null>(`/api/container-dumps/${id}`, { method: 'DELETE' });
}
